import React from 'react';
import Skeleton from 'react-loading-skeleton';

const JobFeedItemLoader = () => (
  <div className="rounded-lg border border-gray-200 p-3 bg-gray-50">
    <div className="flex gap-3">
      <Skeleton circle width={40} height={40} />
      <div className="flex-1">
        <Skeleton width="15%" height={16} />
        <Skeleton width="25%" height={8} />
        <div className="flex flex-row gap-2">
          <Skeleton width={50} height={22} className="rounded-full" />
          <Skeleton width={50} height={22} className="rounded-full" />
          <Skeleton width={50} height={22} className="rounded-full" />
        </div>
      </div>
    </div>
  </div>
);

export default JobFeedItemLoader;
